// 🔧 seo_page_defaults.js
// ✅ Purpose: Shared default SEO draft structure
// ✅ Features:
// - Defines Phase 1 event SEO pages
// - Creates default SEO draft objects
// - Used during event creation
// - Supports future AI SEO generation workflow

export const EVENT_SEO_PAGE_KEYS = [
  "event_home",
  "entries",
  "sponsors",
  "vendors",
  "tickets",
  "auction",
  "store",
  "passport",
  "volunteering",
];

const CORE_EVENT_SEO_PAGE_KEYS = [
  "event_home",
  "entries",
  "volunteering",
];

/**
 * Returns only public SEO pages enabled by an event's package and Power Ups.
 * Existing drafts are never removed when an add-on is later disabled.
 */
export const getEventSeoPageKeys = (event = {}) => {
  const purchasedAddOns = event?.purchasedAddOns || {};
  const hasSponsors =
    purchasedAddOns.sponsors === true ||
    purchasedAddOns.sponsorPayments === true ||
    event?.sponsorPaymentsEnabled === true;
  const hasAuction =
    purchasedAddOns.auction === true || event?.auctionEnabled === true;
  const hasVendors =
    purchasedAddOns.vendors === true ||
    purchasedAddOns.vendorPayments === true ||
    event?.vendorsEnabled === true ||
    event?.vendorPaymentsEnabled === true;
  const hasTickets =
    purchasedAddOns.tickets === true || event?.ticketsEnabled === true;
  const hasStore =
    purchasedAddOns.store === true || event?.storeEnabled === true;
  const hasPassport =
    purchasedAddOns.passport === true || event?.passportEnabled === true;

  return [
    ...CORE_EVENT_SEO_PAGE_KEYS,
    ...(hasSponsors ? ["sponsors"] : []),
    ...(hasVendors ? ["vendors"] : []),
    ...(hasTickets ? ["tickets"] : []),
    ...(hasAuction ? ["auction"] : []),
    ...(hasStore ? ["store"] : []),
    ...(hasPassport ? ["passport"] : []),
  ];
};

export const createDefaultSeoPage = () => ({
  status: "none",

  title: "",
  description: "",

  keywords: [],
  shortSummary: "",

  suggestedOgTitle: "",
  suggestedOgDescription: "",

  generatedAt: null,

  approvedAt: null,
  approvedBy: "",

  rejectedAt: null,
  rejectedBy: "",

  skippedReason: "",
});

export const createDefaultEventSeoPages = (event = {}) =>
  getEventSeoPageKeys(event).reduce((seoPages, pageKey) => {
    seoPages[pageKey] = createDefaultSeoPage();
    return seoPages;
  }, {});
